// import React from 'react';
// import { defaultCountries, parseCountry, PhoneInput } from "react-international-phone";
// import "react-international-phone/style.css";

// const countries = defaultCountries.filter((country) => {
//     const { iso2 } = parseCountry(country);
//     return ['in'].includes(iso2);
// });

// const MyPhoneInput = ({ field, error, isSubmitting, ...props }) => {
//     return (
//         <PhoneInput
//             {...field}
//             {...props}
//             defaultCountry="in"
//             countries={countries}
//             showDisabledDialCodeAndPrefix
//             hideDropdown
//             disableDialCodeAndPrefix
//             className={`w-100 ${error ? "is-invalid" : field.value ? "is-valid" : ""} ${props.className || ""}`}
//             inputClassName="form-control-borderless border-0 w-100 fs-6 bg-transparent"
//             countrySelectorStyleProps={{
//                 buttonClassName: 'country-dropdown-btn h-100 px-3 border-0 d-flex align-items-center gap-2',
//                 flagClassName: 'country-flag',
//             }}
//             disabled={isSubmitting}
//         />
//     );
// };

// export default MyPhoneInput;


import React from 'react';
import { defaultCountries, parseCountry, PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const countries = defaultCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return ['in'].includes(iso2);
});

const MyPhoneInput = ({ field, error, isSubmitting, ...props }) => {
    return (
        <div
            className={`d-flex align-items-stretch p-1 border rounded-3 w-100 ${isSubmitting ? 'bg-light' : 'bg-white'} 
        ${(field.value === "+91") ? 'border-1' : error ? 'border-danger' : 'border-success'}`}
        >
            <PhoneInput
                {...field}
                {...props}
                defaultCountry="in"
                countries={countries}
                hideDropdown
                disableDialCodeAndPrefix
                showDisabledDialCodeAndPrefix
                disabled={isSubmitting}
                className="flex-grow-1"
                inputClassName="w-100 border-0 bg-transparent fs-6 px-1"
                dialCodePreviewStyleProps={{
                    className: "border-0 btn-secondary p-0 fs-6"
                }}
                countrySelectorStyleProps={{
                    buttonClassName:
                        'btn-secondary rounded-start-3 border-0 ps-2 pe-1 d-flex align-items-center gap-2',
                    flagClassName: 'country-flag',

                }}
            />
        </div>
    );
};

export default MyPhoneInput;
